import { render, staticRenderFns } from "./book-dicts@.vue?vue&type=template&id=1610fb27&scoped=true&"
import script from "./book-dicts@.vue?vue&type=script&lang=js&"
export * from "./book-dicts@.vue?vue&type=script&lang=js&"
import style0 from "./book-dicts@.vue?vue&type=style&index=0&id=1610fb27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1610fb27",
  null
  
)

export default component.exports